/**
 * useDebounce Hook (TASK-337, AC-5 / FR-003)
 *
 * Shared debounce hook extracted from the identical private copies in
 * ClientsPage and UsersPage. Returns the given value only after `delay`
 * milliseconds of silence; rapid changes reset the timer.
 */
import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
